import { KeycloakConfig } from 'keycloak-js';

const keycloakConfig: KeycloakConfig = {
    url: 'https://keycloak.dev.mhn.asia',
    realm: 'mpis',
    clientId: 'frontend',
};

const backendConfig = {
    url: 'https://mf.mhnexus.com',
   
};

export const environment = {
    production: false,
    environment: 'dev',
    backend: { ...backendConfig },
    keycloak: { ...keycloakConfig },
    useDefaultMenu: false,
    manifest: 'federation.manifest.dev.json',
    adminRemoteUrl: 'https://mf.mhnexus.com/admin/remoteEntry.json'

};
